import { ISSUE_ATTRIBUTE_NAMES } from '../constants/issue-attribute-names';
import { get as lodashGet } from 'lodash';

export const canAddComment = ({ permittedActions }) => {
  if (!permittedActions) return false;
  return permittedActions.createComment;
};

export const canAdd = (currentUser) => {
  const rfisNew = lodashGet(currentUser, 'attributes.rfis.new');
  return !!rfisNew;
};

export const canAddAttachment = ({ permittedActions }) => {
  if (!permittedActions) return false;
  return permittedActions.createAttachment;
};

export const canDeleteAttachment = ({ permittedActions }) => {
  if (!permittedActions) return false;
  return permittedActions.removeAttachment;
};

export const canChangePushpinVisibility = ({ permittedActions }) => {
  if (!permittedActions) return false;
  return !!permittedActions.togglePushpinVisibility;
};

export const issueLink = {
  _func: null,
  get func() {
    return this._func;
  },
  set func(f) {
    this._func = typeof f === 'function' ? f : null;
  },
};

export const isPushpinVisible = (issue) => {
  return lodashGet(issue, `${ISSUE_ATTRIBUTE_NAMES.PUSHPIN_ATTRIBUTES}.hiddenDocVersion`, null) === null;
};

export const getPushpinVisibilityTextPrefix = (isHiding) => {
  return isHiding ? 'hide' : 'show';
};

export const isIssueInSheet = (issue, currentSheets = []) => {
  const issueSheet = lodashGet(issue, 'sheetMetadata');
  return !issueSheet || currentSheets.length === 0 || !!currentSheets.find(sheet => sheet.sheetGuid === issueSheet.sheetGuid || sheet.sheetName === issueSheet.sheetName);
};

export const getPermittedAttributes = (issue) => {
  return lodashGet(issue, 'permittedActions.updateRfi.permittedAttributes', []);
};

export const isAttributePermitted = (issue, attributeName) => {
  return getPermittedAttributes(issue).map(({ name }) => name).includes(attributeName);
};

export const getPermittedStatuses = (issue) => {
  return lodashGet(issue, 'permittedActions.updateRfi.permittedStatuses', []);
};

export const getTransitionAssignees = (transition) => {
  return lodashGet(transition, 'values.assignedTo', []);
};
